import { useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';

export interface MetricClickThroughSupport {
  systemName: string;
  isSnapshotSupported: boolean;
  isHistoricalSupported: boolean;
}

const GET_METRICS_CLICK_THROUGH_SUPPORT = gql`
  query getMetricsClickThroughSupport {
    getMetricsClickThroughSupport {
      systemName
      isSnapshotSupported
      isHistoricalSupported
    }
  }
`;

export const useGetMetricsClickThroughSupport = () =>
  useGqlQuery<MetricClickThroughSupport[]>({
    query: GET_METRICS_CLICK_THROUGH_SUPPORT,
    queryKey: [QueryKey.GetMetricsClickThroughSupport],
  });
